// extracted by mini-css-extract-plugin
export var linkText = "_p7-0";